import React from "react";
import './styles.scss';
import DATA from 'utils/data.json';
import LOGO_COLOR from 'assets/images/logo-color.png';

const FOOTER_DATA = DATA.footer;

const Footer = () => {
    return (
        <footer className="footer container">
            <img alt='' src={LOGO_COLOR} className='logo' />
            <div className="contact">
                <a href={FOOTER_DATA.facebook} target={'_blank'} rel="noreferrer">
                    <img alt="" src='/images/icon-footer-facebook.svg' />
                </a>
                <a href={FOOTER_DATA.linkedin} target={'_blank'} rel="noreferrer">
                    <img alt="" src='/images/icon-footer-linkedin.svg' />
                </a>
                <a href={FOOTER_DATA.youtube} target={'_blank'} rel="noreferrer">
                    <img alt="" src='/images/icon-footer-youtube.svg' />
                </a>
                <a href={FOOTER_DATA.twitter} target={'_blank'} rel="noreferrer">
                    <img alt="" src='/images/icon-footer-twitter.svg' />
                </a>
            </div>
        </footer>
    )
}

export default Footer